module.exports = __webpack_public_path__ + "img/device_1011_2_select.d769b9dd.svg";